"use client";

import { useEffect, useRef, useState } from "react";

import classNames from "classnames";

import type { LinkRouteDefaults } from "@stadium/shared/src/components/link-with-lang";

import LinkWithLang from "@stadium/shared/src/components/link-with-lang";
import {
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  LinkWithLangType,
} from "@stadium/shared/src/constants/stores/routes";
import styles from "./main.module.scss";
const renderLink = (
  childCategory: any,
  titleClassName: string,
  type: LinkWithLangType,
  linkClassName: string = "",
  linkRouteDefaults?: LinkRouteDefaults,
) => {
  if (!childCategory) return null;
  const { id, code, name } = childCategory;
  return (
    <LinkWithLang
      key={`${id ?? "no-id"}-${code ?? "no-code"}-${name ?? "no-name"}`}
      type={type}
      data={childCategory}
      target={childCategory?.linkToNewTab ? "_blank" : "_self"}
      className={linkClassName}
      {...linkRouteDefaults}
    >
      <div className={titleClassName}>{name}</div>
    </LinkWithLang>
  );
};
const getCategoryAccordionKey = (category: {
  id?: string | number;
  code?: string;
  name?: string;
}) => String(category?.id ?? `${category?.code ?? ""}-${category?.name ?? ""}`);
type CategoryAccordionProps = {
  category: any;
  isOpen: boolean;
  onToggle: () => void;
  linkRouteDefaults?: LinkRouteDefaults;
};
const CategoryAccordionWrapper = ({
  categories,
  linkRouteDefaults,
}: {
  categories: any[];
  linkRouteDefaults?: LinkRouteDefaults;
}) => {
  const [openCategoryKey, setOpenCategoryKey] = useState<string | null>(null);
  return (
    <div className={styles.categorySideBar}>
      {categories.map((category) => {
        const categoryKey = getCategoryAccordionKey(category);
        return (
          <CategoryAccordion
            key={categoryKey}
            category={category}
            isOpen={openCategoryKey === categoryKey}
            onToggle={() =>
              setOpenCategoryKey((prev) => (prev === categoryKey ? null : categoryKey))
            }
            linkRouteDefaults={linkRouteDefaults}
          />
        );
      })}
    </div>
  );
};
const CategoryAccordion = ({
  category,
  isOpen,
  onToggle,
  linkRouteDefaults,
}: CategoryAccordionProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (!contentRef.current) return;
    setContentHeight(contentRef.current.scrollHeight);
  }, [category?.children, isOpen]);

  if (!category) return null;

  if (category?.children?.length === 0) {
    return (
      <div className={classNames(styles.accordion, styles.noChildAccordionHeader)}>
        {renderLink(
          category,
          styles.categoryTitle,
          CATEGORY_PRODUCT_LISTING_LINK_TYPE,
          "",
          linkRouteDefaults,
        )}
      </div>
    );
  }

  return (
    <div className={styles.accordion}>
      <button
        type="button"
        className={classNames("card-header", styles.accordionHeader)}
        onClick={onToggle}
      >
        <div className={styles.collapseBlock}>
          <div className={styles.categoryTitle}>{category?.name ?? ""}</div>
          <div className={styles.collapseIconBlock}>
            <span className={` ${styles.arrowIcon} ${isOpen ? styles.iconUp : styles.iconDown}`} />
          </div>
        </div>
      </button>
      <div
        className={styles.subCategoryWrapper}
        style={{ maxHeight: isOpen ? `${contentHeight}px` : "0px" }}
      >
        <div ref={contentRef} className={styles.subCategoryBlock}>
          {category?.children?.map((childCategory) =>
            renderLink(
              childCategory,
              styles.subCategoryName,
              CATEGORY_PRODUCT_LISTING_LINK_TYPE,
              styles.subCategoryLink,
              linkRouteDefaults,
            ),
          )}
        </div>
      </div>
    </div>
  );
};
export default CategoryAccordionWrapper;
